import React, {Component} from 'react'
import {Form, Input, Row, Col, Select, DatePicker, Button, Table, message, Upload, Popconfirm} from 'antd';
import {reqDeviceList, reqAddDevice, reqDeleteDevice, reqUpdateDevice} from '../../api'
import DeviceModal from './device-model'
import LinkButton from '../../components/link-button'
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)
moment.locale('zh-cn');
class DeviceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0, // 商品的总数量
            orderList: [], // 商品的数组
            pageNum: 1,
            from: null,
            deviceData: {},
            deviceView: false,
            gpsId: '',
            to: null,
            action: ''
        }
    };

    getProducts = async (pageNum) => {
        const pageSize = 10
        this.setState({
            pageNum: pageNum// 保存pageNum, 让其它方法可以看到
        })
        const {getFieldsValue} = this.props.form
        const values = getFieldsValue();
        const {from, to} = this.state
        values.from = from;
        values.to = to;
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqDeviceList(values)
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {

        }

    }

    onRef = (ref) => {
        this.child = ref
    }


    componentDidMount() {
        this.getProducts(1)
    }

    /*查询列表*/
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.pageNum = 1
            values.pageSize = 10;
            this.setState({
                pageNum:values.pageNum
            })
            const {from, to} = this.state
            values.from = from;
            values.to = to;
            if (!err) {
                this.getDeviceList(values);
            }
        });
    };

    // 查询
    getDeviceList = async (po) => {
        const result = await reqDeviceList(po);
        if (result.code === 200) {
            this.setState({
                total: result.data.total,
                orderList: result.data.rows
            })
        } else {
            message.error(result.message);
        }
    };

    // 新增
    getAddDeviceList = async (po) => {
        const {pageNum} = this.state
        const result = await reqAddDevice(po);
        if (result.code === 201) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };


    // 删除
    getDeleteDevice = async (id) => {
        const {pageNum} = this.state
        const result = await reqDeleteDevice(id);
        if (result.code === 201) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 更新
    getUpdateDevice = async (po) => {
        const {pageNum} = this.state
        const result = await reqUpdateDevice(po);
        if (result.code === 200) {
            this.getProducts(pageNum)
        } else {
            message.error(result.message);
        }
    };

    // 日期选择
    onDateChange = (value, dateString) => {
        this.setState({
            from: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        this.setState({
            to: dateString
        })
    }

    // 新增

    addDevice = () => {
        this.setState({
            deviceView: true,
            action: 'add',
        })
    }

    // 修改
    updateDevice = (data) => {
        this.setState({
            deviceView: true,
            action: 'update',
            gpsId: data.id
        })
        let formDate = {}
        if (data.lastSynDt) {
            formDate.lastSynDt = moment(data.lastSynDt, 'YYYY-MM-DD hh:mm:ss')
        }
        formDate.deviceId = data.deviceId;
        formDate.factoryCode = data.factoryCode;
        this.child.props.form.setFieldsValue(formDate);
    }

    onOk = data => {
        const {action, gpsId} = this.state;
        if (action === 'add') {
            this.getAddDeviceList(data)
            this.onCancel();
        } else {
            const updateData = {
                ...data,
                id: gpsId
            }
            this.getUpdateDevice(updateData)
            this.setState({deviceView: false, deviceData: {}});
        }
    }

    onCancel = () => {
        this.setState({
            deviceView: false
        })
    }

    render() {

        const form = this.props.form
        const {getFieldDecorator} = form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 9},
                sm: {span: 9},
            },
            wrapperCol: {
                xs: {span: 13},
                sm: {span: 13},
            },
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        }

        // 取出状态数据
        const {orderList, total, deviceView, deviceData} = this.state
        const columns = [
            {
                title: 'GPS设备号',
                dataIndex: 'deviceId',
                width: '30%',
                render: (text, record) => (
                    <a onClick={() => this.props.history.push('/gpsDetail', record)}>{text}</a>
                )
            },{
                title: '厂家名称',
                dataIndex: 'factoryCodeName',
            }, {
                title: '最后同步时间',
                dataIndex: 'lastSynDt',
            }, {
                title: '操作',
                dataIndex: 'opt',
                fixed: 'right',
                width: 150,
                render: (text, record) => {
                    return <span>
                       <AuthLinkButton authority="gps:update"
                                       onClick={() => this.updateDevice(record)}>修改</AuthLinkButton>
                             <Popconfirm title="是否确定删除?" onConfirm={() => this.getDeleteDevice(record.id)}>
                            <AuthLinkButton authority="gps:delete">删除</AuthLinkButton>
                        </Popconfirm>

                        </span>
                }
            }
        ];
        return (
            <div className='box-shadow padding-20'>
                <div className='head-title'>GPS设备列表</div>
                <br/>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={6}>
                            <Form.Item label="GPS设备号">
                                {getFieldDecorator('deviceId', {})(<Input />)}
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="最后同步时间" className='time-input-to'>
                                {getFieldDecorator('from')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange}
                                    style={{width: "100%", minWidth: 10}}
                                />)}

                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label='至' className='time-input-to'>
                                {getFieldDecorator('to')(<DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={this.onDateChange2}
                                    style={{width: "100%", minWidth: 10}}
                                />)}
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{float: 'right', marginTop: '4px'}}>
                            <Button type='primary' htmlType="submit"
                                    style={{marginRight: '16.7%'}}>查询</Button>
                            <AuthButton authority="gps:add" type="primary" onClick={this.addDevice}>新增</AuthButton>
                        </Col>
                    </Row>
                </Form>

                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    bordered
                    dataSource={orderList}
                    rowKey='id'
                    pagination={{
                        current: this.state.pageNum,
                        total: total,
                        showQuickJumper: true,
                        onChange: this.getProducts
                    }}
                    size="middle"
                />
                <DeviceModal
                    onRef={this.onRef}
                    onOk={this.onOk}
                    action={this.state.action}
                    deviceView={deviceView}
                    deviceData={deviceData}
                    onCancel={this.onCancel}
                />
            </div>

        )
    }
}
const WrapDeviceList = Form.create()(DeviceList)
export default WrapDeviceList